import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  IDamageArea,
  IDamageSeverity,
  IDamageSeverityCreateRequest,
  IDamageType,
  IDamageTypeCreateRequest,
  IPart,
  IPartCreateRequest,
} from './parts-manager.models';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PartsManagerService {
  private readonly http = inject(HttpClient);

  public getParts(): Observable<IPart[]> {
    return this.http.get<IPart[]>(
      `${environment.services.masterdata}/api/parts-manager/parts`
    );
  }

  public getDamageTypes(): Observable<IDamageType[]> {
    return this.http.get<IDamageType[]>(
      `${environment.services.masterdata}/api/parts-manager/types`
    );
  }

  public getDamageSeverities(): Observable<IDamageSeverity[]> {
    return this.http.get<IDamageSeverity[]>(
      `${environment.services.masterdata}/api/parts-manager/severities`
    );
  }

  public getDamageAreas(): Observable<IDamageArea[]> {
    return this.http.get<IDamageArea[]>(
      `${environment.services.masterdata}/api/parts-manager/areas`
    );
  }

  public createPart(part: IPartCreateRequest): Observable<IPart> {
    return this.http.post<IPart>(
      `${environment.services.masterdata}/api/parts-manager/parts`,
      part
    );
  }
  public createDamageType(
    damageType: IDamageTypeCreateRequest
  ): Observable<IDamageType> {
    return this.http.post<IDamageType>(
      `${environment.services.masterdata}/api/parts-manager/types`,
      damageType
    );
  }
  public createDamageSeverity(
    severity: IDamageSeverityCreateRequest
  ): Observable<IDamageType> {
    return this.http.post<IDamageSeverity>(
      `${environment.services.masterdata}/api/parts-manager/severities`,
      severity
    );
  }
  public updatePart(
    id: number,
    areaIds: number[],
    code: string
  ): Observable<IPart> {
    return this.http.put<IPart>(
      `${environment.services.masterdata}/api/parts-manager/parts/${id}`,
      {
        areaIds,
        name: code,
        isActive: true,
      }
    );
  }
  public deletePart(part: IPart): Observable<IPart> {
    return this.http.put<IPart>(
      `${environment.services.masterdata}/api/parts-manager/parts/${part.id}`,
      {
        ...part,
        name: part.code,
        areaIds: part.areas.map((part) => part.id),
        isActive: false,
      }
    );
  }
  public deleteType(body: IDamageType): Observable<IDamageType> {
    return this.http.put<IDamageType>(
      `${environment.services.masterdata}/api/parts-manager/types/${body.id}`,
      {
        ...body,
        name: body.code,
        isActive: false,
      }
    );
  }
  public deleteSeverity(body: IDamageSeverity): Observable<IDamageSeverity> {
    return this.http.put<IDamageSeverity>(
      `${environment.services.masterdata}/api/parts-manager/severities/${body.id}`,
      {
        ...body,
        name: body.code,
        isActive: false,
      }
    );
  }
}
